import { jsx as _jsx } from "react/jsx-runtime";
import Notification from '../Notification/Notification';
import { ToastItemRoot } from './ToastItem.styled';
import { useToastItem } from './ToastItem.hook';
// Component.
// -----------------------------------------------------------------------------
export const ToastItem = ({ duration, maxWidth, message, id, onRemove, title, type }) => {
    // Hooks.
    // ---------------------------------------------------------------------------
    const { isVisible } = useToastItem({ duration, id, onRemove });
    // Guard condition.
    // ---------------------------------------------------------------------------
    if (!isVisible) {
        return null;
    }
    // Render.
    // ---------------------------------------------------------------------------
    return (_jsx(ToastItemRoot, { id: `toast-item-${id}`, maxWidth: maxWidth, children: _jsx(Notification, { message: message, style: {
                marginBottom: 0
            }, title: title, type: type }) }));
};
//# sourceMappingURL=ToastItem.js.map